import { useState, useEffect } from 'react';
const BLANK_SPACE_HEIGHT = 70;

export const useWindowInputScroll = (available: boolean = true) => {
  const [maxSize, setMaxSize] = useState<number>(window.innerHeight);
  const [maxOffset, setMaxOffset] = useState<number>(0);
  const [difference] = useState<number>(
    window.outerHeight - window.innerHeight
  );
  const [timer, setTimer] = useState<number>(0);
  const [scrollState, setScrollState] = useState<'stop' | 'scrolling'>('stop');

  useEffect(() => {
    if (!available || !difference) return;
    const debounceScrollUpdate = () => {
      window.clearTimeout(timer);
      const timer2 = window.setTimeout(() => {
        if (maxOffset === 0 || scrollState === 'stop') return;

        if (
          maxSize > window.outerHeight - difference &&
          maxOffset >= window.innerHeight
        ) {
          window.scrollBy({
            top: -BLANK_SPACE_HEIGHT,
            left: 0,
            behavior: 'smooth',
          });
        }

        if (
          maxSize <= window.outerHeight - difference &&
          maxOffset >= window.innerHeight
        ) {
          window.scrollBy({
            top: -BLANK_SPACE_HEIGHT,
            left: 0,
            behavior: 'smooth',
          });
        }
        setScrollState('stop');
        setMaxSize(0);
        setMaxOffset(0);
      }, 100);
      setTimer(timer2);
    };

    const handleScroll = () => {
      setScrollState('scrolling');
      if (window.pageYOffset > maxOffset) {
        setMaxOffset(window.pageYOffset);
      }
      if (window.innerHeight > maxSize) {
        setMaxSize(window.innerHeight);
      }
      if (window.pageYOffset > maxSize) {
        setMaxSize(window.pageYOffset);
      }
      debounceScrollUpdate();
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });
};
